module.exports = __webpack_public_path__ + "static/media/29EUNOG15.73ff2378.jpg";